import { useI18n } from "../i18n";
import { Drawer } from "./Drawer";

/** The four-line rules card plus the glossary, folded away until wanted. */
export function HelpPanel() {
  const { t, glossary } = useI18n();
  return (
    <Drawer className="panel help" title={t("help.title")} testId="help-panel">
      <ol>
        <li>{t("help.step1")}</li>
        <li>{t("help.step2")}</li>
        <li>{t("help.step3")}</li>
        <li>{t("help.step4")}</li>
      </ol>

      <h3 className="subhead">{t("help.glossaryTitle")}</h3>
      <dl className="glossary">
        {glossary.map((entry) => (
          <div className="glossary__row" key={entry.id}>
            <dt>{entry.term}</dt>
            <dd>{entry.meaning}</dd>
          </div>
        ))}
      </dl>
    </Drawer>
  );
}
